/* tslint:disable */

declare var Object: any;
export interface StorageInvitationInterface {
  "id"?: number;
}

export class StorageInvitation implements StorageInvitationInterface {
  "id": number;
  constructor(data?: StorageInvitationInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `StorageInvitation`.
   */
  public static getModelName() {
    return "StorageInvitation";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of StorageInvitation for dynamic purposes.
  **/
  public static factory(data: StorageInvitationInterface): StorageInvitation{
    return new StorageInvitation(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'StorageInvitation',
      plural: 'StorageInvitations',
      path: 'StorageInvitations',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/StorageInvitation.ts